import React from "react"
import styled from "styled-components"
import { primaryLight } from "../../../constants/colors"
import { MenuItemType } from "../../../model/FooterType"
import { Link } from "gatsby"
import { screenSizes } from "model"
import { safeHeDecode } from "../../../util/generalUtil"

const Wrapper = styled.div`
  line-height: 1.5;
  margin-right: 10%;

  @media (max-width: ${screenSizes.tablet}px) {
    margin-bottom: 10%;
    margin-left: 10%;
  }
`

const Header = styled.h4`
  color: ${primaryLight};
`

const StyledLink = styled(Link)`
  font-size: 0.8em;
  text-transform: uppercase;
  font-weight: bold;
`

const Item = styled.div`
  display: flex;
  align-items: center;

  svg {
    display: block;
    width: 30px;
    margin-right: 5px;
  }
`

interface Props {
  title: string
  items: MenuItemType[]
}

const LinkColumn = ({ title, items }: Props): JSX.Element => {
  return (
    <Wrapper>
      <Header>{title}</Header>
      {items.map(({ id, url, label, Svg, external }) => (
        <StyledLink key={id} to={url} target={external ? "_blank" : "_self"}>
          <Item>
            {Svg && <Svg />}
            {safeHeDecode(label || "")}
          </Item>
        </StyledLink>
      ))}
    </Wrapper>
  )
}

export default LinkColumn
